import axios from 'axios';
import { configRefs } from '@utils/constants';

async function getTeamsRequest(user) {
  if (!user || user.role !== "teacher") {
    return [];
  }
  const res = await axios.get(`${await configRefs.apis.userdata.get()}/api/Filters?userID=${user.id}`);
  return res.data.map(it => ({
    id: it.objectID,
    key: it.objectID,
    createdAt: new Date(it.created * 1000),
    modifiedAt: new Date(it.modified * 1000),
    enabledNotifications: it.enableNotifications,
    title: it.title,
    subjects: it.subjects,
    teams: it.teams
  }));
}

export { getTeamsRequest };
//# sourceMappingURL=api.get-teams.request.js.map
